import * as React from 'react'
import * as Redux from 'react-redux'
import { Dispatch } from 'redux'

import * as model from '@owl-nest/models'
import * as layout from '../layout'
import { LinkAsButton, Button, styles as S } from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'

import * as projectModel from '../../../models/project'
import * as projectAction from '../../../../actions/project'

type ExamplesProps = {
  initialOpen: boolean
  project: projectModel.Project
  markStepDone: () => Promise<void>
}

export function Examples({
  initialOpen,
  project,
  markStepDone,
}: ExamplesProps): React.ReactElement<ExamplesProps> | null {
  const manager = project.manager || project.default_manager
  const [open, setIsOpen] = React.useState(initialOpen)
  const dispatch = Redux.useDispatch<Dispatch>()

  if (manager === undefined) {
    return null
  }

  const mainTag = project.main_tag
  const category = mainTag ? model.i18n.get(mainTag.name) : undefined

  return (
    <layout.Coach
      closable={true}
      open={open}
      title={t('Need inspiration?')}
      onClose={() => handleDone(true)}
      avatar={model.image.getUrl(manager.avatar.versions, '128x128')}
    >
      <S.copy.S.regular>
        {t(
          'I found some awesome %(category)s projects that will inspire you and help you build your page! Interested?',
          {
            category,
          },
        )}
      </S.copy.S.regular>
      <Button kind="primary" onClick={goToDiscussion}>
        {t('See examples')}
      </Button>
      <LinkAsButton kind="secondary" onClick={() => handleDone(true)}>
        {t('Later')}
      </LinkAsButton>
    </layout.Coach>
  )

  async function handleDone(delay: boolean): Promise<void> {
    setIsOpen(false)
    await markStepDone()
    await computeExample(delay)
  }

  async function computeExample(withDelay: boolean): Promise<void> {
    const isProjectOnline = project.is_online
    return dispatch(
      projectAction.computeExamples(project, isProjectOnline ? { force_recompute: true } : { with_delay: withDelay }),
    )
  }

  async function goToDiscussion(): Promise<void> {
    await handleDone(false)
    window.location.href = `/projects/${project.id}/discussion/#last-message`
  }
}
